import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./PaymentOptions.css";
import stripeLogo from '../../assets/img/stripe.svg'
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { ClipLoader } from "react-spinners";
import {
    BASE_URL,
    paypalAuthToken,
    paypalPaymentIntentSecret,
    paypalOrderCapture,
    PAYPAL_CLIENT_ID,
} from "../../utils/Constants";
import { useDispatch, useSelector } from "react-redux";
import { getNannyProfileById } from "../../store/apiSlice/NannyprofileByIdSlice";

const PaymentOptions = () => {
    const dispatch = useDispatch();
    const profileByIdData = useSelector((state) => state.rootReducer.nannyProfileByIdReducer.data);
    const location = useLocation();
    const navigate = useNavigate();
    const [clientToken, setClientToken] = useState(null);
    const [nannyProfile, setNannyProfile] = useState(null)
    const token = localStorage.getItem("Token");
    if (!token) {
        alert("Please login, your token is expired.");
        navigate("/login");
        window.location.reload();
    }
    const {
        address,
        date,
        time,
        counter,
        divs,
        categoryId,
        price,
        firstName,
        lastName,
        nannyId,
        orderId,
        bookingId
    } = location.state;

    useEffect(() => {
        if (nannyId) {
            dispatch(getNannyProfileById(nannyId));
        }
    }, []);

    useEffect(() => {
        if (profileByIdData != null && profileByIdData.status === 1) {
            setNannyProfile(profileByIdData.data)
        }
        else if (profileByIdData != null) {
            alert(profileByIdData.message)
        }
    }, [profileByIdData])

    useEffect(() => {
        fetch(`${BASE_URL}${paypalAuthToken}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
        })
            .then((res) => res.json())
            .then((data) => setClientToken(data?.data?.client_token))
            .catch((err) => console.error("Failed to fetch client token", err));
    }, []);


    const handleStripeClick = () => {
        navigate("/StipePayment", {
            state: {
                address,
                date,
                time,
                counter,
                divs,
                categoryId,
                price,
                firstName,
                lastName,
                nannyId,
                orderId,
                bookingId
            },
        });
    };


    if (!clientToken)
        return (
            <div
                className="container sections_padding"
                style={{
                    marginTop: "30vh",
                    minHeight: "50vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                }}
            >
                <ClipLoader color="#89d6ce" size={30} width={50} />
            </div>
        );

    return (
        <div className="payment-container">
            <h2 className="payment-title">Select Payment Method</h2>
            <div className="payment-buttons">
                {/* {nannyProfile && nannyProfile.isStripeConnected === 1 &&  */}
                <button className="stripe-btn" onClick={handleStripeClick}>
                    <img
                        src={stripeLogo}
                        alt="Stripe"
                        className="Stripe"
                        style={{ width: '100px', height: '20px', display: 'block', margin: '0 auto' }}
                    />


                </button>
                
                {/* {nannyProfile && nannyProfile.isPaypalConnected === 1 &&  */}
                <PayPalScriptProvider
                    style={{}}
                    options={{
                        "client-id": PAYPAL_CLIENT_ID,
                        "data-client-token": clientToken,
                        components: "buttons,hosted-fields",
                        intent: "capture",
                        currency: "EUR",
                    }}
                >
                    <PayPalButtons
                        style={{
                            layout: "horizontal",
                            color: "white",
                            tagline: false,
                            shape: "rect",
                            disableMaxWidth: true,
                            height: 49,
                        }}
                        createOrder={async () => {
                            try {
                                const response = await fetch(
                                    `${BASE_URL}${paypalPaymentIntentSecret}?bookingId=${bookingId}&orderId=${orderId}&price=${price}`,
                                    {
                                        method: "GET",
                                        headers: {
                                            "Content-Type": "application/json",
                                            Authorization: token,
                                        },
                                    }
                                );

                                const orderData = await response.json();
                                if (orderData?.data?.id) {
                                    return orderData?.data?.id;
                                } else {
                                    alert("Failed to initialize paypal payment");
                                    return;
                                }
                            } catch (error) {
                                alert("Failed to initialize paypal payment");
                                return;
                            }
                        }}
                        onApprove={async (data, actions) => {
                            try {
                                const response = await fetch(
                                    `${BASE_URL}${paypalOrderCapture}${data.orderID}/capture`,
                                    {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                            Authorization: token,
                                        },
                                    }
                                );

                                const orderData = (await response.json()).data;
                                if (orderData.status === "COMPLETED") {
                                    navigate("/paypal-payment-success");
                                } else {
                                    alert("Payment Failed");
                                    navigate("/payment-options");
                                }
                            } catch (error) {
                                console.error(error);
                                alert(`Sorry, your transaction could not be processed...`);
                            }
                        }}
                    />
                </PayPalScriptProvider>
            </div>
        </div>
    );
};

export default PaymentOptions;
